import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';

import { Storage } from '@ionic/storage';

/*
  Generated class for the AuthServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AuthServiceProvider {

  public token: any;
  serverServicios = "";
  public usuario:any={};
  constructor(public http: Http, public storage: Storage) {
  	//this.serverServicios = "http://localhost:3000";
    this.serverServicios = "http://165.227.106.28:3000";

  }

  checkAuthentication(){
 
    return new Promise((resolve, reject) => {
 
        //Load token if exists
        this.storage.get('token').then((value) => {
            this.token = value;
            
            if(this.token === null || this.token.length == 0)
              reject("");
            else{
              this.storage.get("entidad").then((en) => {
                  this.usuario["entidad"] = en;
                  
                  this.storage.get("identidad").then((id) => {
                      this.usuario["identidad"] = id;

                      this.storage.get("idtusuario").then((idt) => {
                        this.usuario["idtusuario"] = idt;

                        let headers = new Headers();
                        headers.append('Authorization', this.token);
           
                        this.http.get(this.serverServicios + '/posdepartamento/1/1', {headers: headers}).subscribe(res => {
                                resolve(res);
                            }, (err) => {
                                reject(err);
                            });

                      });
                  });
              });
            }
        }); 
    });
  }

  login(credentials){
  	return new Promise((resolve, reject) => {
  		let headers = new Headers();
        headers.append('Content-Type', 'application/json');
 
        this.http.post(this.serverServicios + '/auth/login', JSON.stringify(credentials), {headers: headers})
          .subscribe(res => {

            let data = res.json();
            this.token = data.token;
            
            this.storage.set('entidad', data.entidad).then(e => {
              this.storage.set('token', data.token).then(t => {
                this.storage.set('idtusuario', data.idtusuario).then(idt => {
                  this.storage.set('identidad', data.identidad).then(ide => {
                    this.usuario["identidad"] = data.identidad;
                    this.usuario["entidad"] = data.entidad;
                    this.usuario["idtusuario"] = data.idtusuario;

                    resolve(res.json());
                  })
                })
              })
            })

          }, (err) => {
            reject(err);
          });
    });
  }

  actualizarpwd(user){
    return new Promise((resolve, reject) => {
      let headers = new Headers();
        headers.append('Content-Type', 'application/json');
 
        this.http.post(this.serverServicios + '/auth/actualizarpwd', JSON.stringify(user), {headers: headers})
          .subscribe(res => {
            resolve(res.json());
          }, (err) => {
            reject(err);
          });
    });
  }

  recuperar(user){
    return new Promise((resolve, reject) => {
      let headers = new Headers();
        headers.append('Content-Type', 'application/json');
 
        this.http.post(this.serverServicios + '/auth/recuperar', JSON.stringify(user), {headers: headers})
          .subscribe(res => {
            resolve(res.json());
          }, (err) => {
            reject(err);
          });
    });
  }

  logout(){
    this.storage.set('token', '');
    this.storage.set('idtusuario', '');
    this.storage.set('identidad', '');
    this.storage.set('entidad', '');
    this.storage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth-service/auth-service.ts